import React from "react";
import styles from "../styles/loginLoader.module.css";
export default function LoginLoader() {
  return <div className={styles.loading_container} data-sentry-component="LoginLoader" data-sentry-source-file="loginLoader.jsx">
      <div className={styles.dot_windmill}></div>
    </div>;
}